import { minutesToMilliseconds } from "date-fns";

import { GetScimLogsParams, getScimLogs } from "../../services/defs/internal-api/scim-logs";

export const scimLogsQuery = ({ scimToken, scimId, limit, skip, sort, userEmail, filters }: GetScimLogsParams) => ({
	queryKey: ["get-scim-logs-by-query", { scimToken, scimId, limit, skip, sort, userEmail, filters }],
	queryFn: () => getScimLogs({ scimToken, scimId, limit, skip, sort, userEmail, filters }),
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting SCIM logs.",
	},
});
